import type { GetFileAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetFileAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetFileAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetFileAuditByIdArgs = {
  id: string;
};

export const useGetFileAuditById = createQueryHook<
  UseGetFileAuditByIdArgs,
  GetFileAuditByIdResponseRow[],
  GetFileAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getFileAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ file_audit: data }),
  graphqlDocument: GetFileAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
